import { useStyles } from './useStyles';
import React from 'react';
import { UsageProgress } from 'src/components/UsageProgress';
import PropTypes from 'prop-types';
import { PerformanceRowsLimitTooltip } from 'src/components/PerformanceRowsLimitTooltip';
import { Information } from 'src/components/Information';
import { InlineUpgradeButton } from 'src/components/InlineUpgradeButton';
import { useGetUpgradeRowsLimitButtonAttributes } from 'src/services';
import cx from 'classnames';

export const FeatureLimitedProgressBar = ({
  upgradeUrl,
  data = {},
  upgradeActionOrigin,
  connectedAccounts,
}) => {
  const styles = useStyles();
  const { currentCount, limit } = data;
  const isFeatureLimited = currentCount >= limit;
  const { shortUpgradeButtonText, isBusinessPlan } =
    useGetUpgradeRowsLimitButtonAttributes(upgradeUrl);

  return (
    <div className={cx(styles.root, { [styles.businessPlanWidth]: isBusinessPlan })}>
      <div className={styles.topContainer}>
        <div className={styles.limitLabelContainer}>
          <span data-testid="FeatureLimitedProgressBar_limitCountLabel">
            <span className={styles.limitLabel}>
              {isFeatureLimited ? limit : currentCount}/{limit}
            </span>{' '}
            rows (copy assets) used {currentCount ? `in ${connectedAccounts?.length} accounts` : ''}
          </span>
          <Information
            className={styles.informationIcon}
            content={<PerformanceRowsLimitTooltip connectedAccounts={connectedAccounts} />}
          />
        </div>
        <InlineUpgradeButton
          actionsOrigin={upgradeActionOrigin}
          upgradeUrl={upgradeUrl}
          className={styles.upgradeButton}
          dataTestId="integrations_upgradeButton"
          text={shortUpgradeButtonText}
        />
      </div>
      <UsageProgress
        classes={{
          bar: isFeatureLimited ? styles.limitBar : styles.bar,
          linearProgress: styles.linearProgress,
        }}
        value={currentCount}
        limit={limit}
      />
    </div>
  );
};

FeatureLimitedProgressBar.displayName = 'FeatureLimitedProgressBar';
FeatureLimitedProgressBar.propTypes = {
  upgradeUrl: PropTypes.string,
  upgradeActionOrigin: PropTypes.string,
  data: PropTypes.shape({
    currentCount: PropTypes.number,
    limit: PropTypes.number,
  }).isRequired,
  connectedAccounts: PropTypes.array,
};

FeatureLimitedProgressBar.defaultProps = {
  upgradeUrl: '',
  upgradeActionOrigin: '',
  connectedAccounts: [],
};
